import { LitElement, html, css } from 'lit-all'

class NovaCheckboxWrapper extends LitElement {
  static properties = {
    checked: {
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.checked = this.querySelector('input')?.checked
  }

  onChange(e) {
    this.checked = e?.target?.checked
  }

  render() {
    return html`
      <div>
        <slot @change="${this.onChange}" name="input"></slot>
        <slot name="label"></slot>
        <slot name="checkmark"></slot>
      </div>
    `
  }

  static styles = css`
    ::slotted(input) {
      width: var(--nova-width, 16px);
      height: var(--nova-height, 16px);
      position: absolute;
      top: 0;
      left: 0;
      border: none;
      appearance: none;
      padding: 0;
      margin: 0;
    }

    ::slotted(label) {
      cursor: pointer;
    }

    ::slotted(label):before {
      content: '';
      -webkit-appearance: none;
      background-color: transparent;
      border: 1px solid var(--nova-color, #000);
      width: var(--nova-width, 16px);
      height: var(--nova-height, 16px);
      display: inline-block;
      position: relative;
      vertical-align: middle;
      cursor: pointer;
      margin-right: 5px;
      box-sizing: border-box !important;
      border-radius: 10px;
    }

    :host {
      position: relative;
      display: block;
    }

    :host([checked='true']) ::slotted(label):after {
      content: '';
      position: absolute;
      top: var(--nova-check-top, 4px);
      left: var(--nova-check-left, 4px);
      width: var(--nova-check-width, 8px);
      height: var(--nova-check-height, 8px);
      background-color: var(--nova-color, #000);
    }
  `
}

customElements.define('nova-checkbox-wrapper', NovaCheckboxWrapper)
